module.exports = __webpack_public_path__ + "static/media/megak.322cdb8b.webp";